import * as React from 'react';
import { TextContent, Text, TextVariants } from '@patternfly/react-core';
import './ErrorPage.scss';
import { ArrowRightIcon } from '@patternfly/react-icons';
import { map } from 'lodash';
import Env from 'utils/env';
import { ISuggestionLinks } from '../../../interfaces/errorPage';


export interface IErrorPageProps {
  errorCode?: any;
  title?: string;
  description?: string;
  shortDescription?: string;
  suggestionLinks?: Array<ISuggestionLinks>;
}

const ErrorPage: React.FC<IErrorPageProps> = (props) => {

  const envName = Env.getEnvName();
  const feedbackURL = `${Env.ConnectPortalUrls[envName]}contact`;

  return (
    <div className="rhc-project-error">
      <TextContent className="rhc-project-error__gradient">
        <TextContent className="rhc-project-error__gradient__masthead">
          {props.title && <Text className="rhc-project-error__gradient__masthead__header">{props.title}</Text>}
          {props.description && <Text className="rhc-project-error__gradient__masthead__desc">{props.description}</Text>}
          {props.shortDescription && <Text className="rhc-project-error__gradient__masthead__desc">{props.shortDescription}</Text>}
        </TextContent>
      </TextContent>
      <TextContent className="rhc-project-error__relative-position-cards rhc-project-error__content">
        <Text className="rhc-project-error__content__header">Try one of these instead</Text>
        <TextContent className="rhc-project-error__content__link-list">
          <TextContent className="rhc-project-error__content__link-list__link">
            {map(props.suggestionLinks, (item, idx) => {
              return (
                <Text className="rhc-project-error__content__link-list__link__item" component={TextVariants.a} href={item.link} key={`suggestion-link-${idx}`}>{item.text}</Text>
              );
            })}
          </TextContent>
        </TextContent>
        <TextContent className="rhc-project-error__content__feedback">
          {props.errorCode && <Text>We've logged this as {props.errorCode} error, but you can also provide more information.</Text>}
          <Text component={TextVariants.a} className="rhc-project-error__content__feedback__link" href={feedbackURL} target={envName === 'DEV' ? '_blank' : '_self'}>
            Tell us what went wrong
            <span className="rhc-project-error__content__feedback__arrow"><ArrowRightIcon /></span>
          </Text>
        </TextContent>
      </TextContent>
    </div>
  );
}

export default ErrorPage;